import type { Advisor } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get } from './request';

export const SERVICE_PATH = 'rest/resource/advisor';
export const sitecoreServiceUrl = '/api/employee/getbyemail';

export interface SitecoreResponseObject {
    navn: string;
    epost: string;
    telefon: string;
    bilde: string;
}

export async function getImage(email?: string): Promise<string | undefined> {
    return email ? (await get<SitecoreResponseObject>(`${sitecoreServiceUrl}?email=${email}`)).bilde : undefined;
}

export async function getAdvisor(): Promise<Advisor> {
    return get<Advisor>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}
